import React from "react";
import { Box, Card, Typography, Grid, Chip, Paper, Backdrop, CircularProgress, Skeleton } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { getStatusColor } from "../PayrollMgLandingPage";
import ArrowBackButton from "../../../../Base/views/ArrowBackButton";
import WorkBasedEmployees from "../WorkBasedEmployees";
import RegularEmployees from "../RegularEmployees";
import { useSelector } from "react-redux";
import { ConvertDate } from "../../../../Base/helper/baseFunctions";
import ContractualEmployees from "../ContractualEmployees";

const MonthlyManagementView = ({
  selectedYear,
  selectedMonth,
  setCurrentView,
  currentMonthData,
  userRole,
  paydate,
  worklocationData,
  handleWorkLoacation,
  currentType,
  onBack
}) => {
  const { payrollTileViewLoading } = useSelector(
      (state) => state.FinanceReducer?.PayrollManagementReducer
    );
  const currentStatus =
    currentType === "Regular"
      ? currentMonthData?.["Regular_status"]
      : currentType === "Work-Based"
      ? currentMonthData?.["Work-Based_status"]
      : currentMonthData?.["Contractual_status"];
  return (
    <Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={payrollTileViewLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card sx={{ mb: 2, borderRadius: 2, boxShadow: 2, px: 2, py: 1 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Box display="flex" alignItems="center" gap={2}>
              <ArrowBackButton
                onClick={() => {
                  if (onBack) onBack();
                  else setCurrentView("dashboard");
                }}
                sx={{ fontSize: 40, color: "primary.main" }}
              />
              <AccountBalanceWalletIcon
                sx={{ fontSize: 40, color: "primary.main" }}
              />
              <Box>
                <Typography variant="h4" fontWeight={700} color="text.primary">
                  {`PayRun > ${currentType}`}
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ mt: 1 }}
                >
                  Manage and process employee payroll
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item>
            <Box display="flex" alignItems="start" gap={4}>
             {payrollTileViewLoading ? (
              <>
                <Box textAlign="right">
                  <Skeleton variant="text" width={100} height={24} sx={{ mb: 1 }} />
                  <Skeleton variant="text" width={80} height={28} />
                </Box>
                <Box textAlign="center">
                  <Skeleton variant="text" width={60} height={24} sx={{ mb: 1 }} />
                  <Skeleton variant="rounded" width={80} height={32} />
                </Box>
              </>
            ) : ( 
            <>
              {paydate?.start_date ? (
                <Box textAlign="right">
                  <Typography variant="body2" color="text.secondary" textAlign={"start"}>
                    Current Pay Period
                  </Typography>
                  <Typography variant="subtitle1" fontWeight={600} pt={1}>
                    {ConvertDate(paydate?.start_date)} - {ConvertDate(paydate?.end_date)}
                  </Typography>
                </Box>
              ) : (
                <Box textAlign="right">
                  <Skeleton variant="text" width={100} height={24} sx={{ mb: 1 }} />
                  <Skeleton variant="text" width={80} height={28} />
                </Box>
              )} 
              <Box textAlign="center">
                <Typography variant="body2" color="text.secondary">
                  Status
                </Typography>
                <Box>
                  <Chip
                    label={currentStatus}
                    sx={{
                      backgroundColor: getStatusColor(currentStatus)?.bg,
                      color: getStatusColor(currentStatus)?.text,
                      fontWeight: 500,
                      height: "30px",
                    }}
                  />
                </Box>
              </Box>
              </>)}
            </Box>
          </Grid>
        </Grid>
      </Card>
      <Paper sx={{ borderRadius: "10px", minHeight: "87vh" }}>
        <Box sx={{ width: "100%" }}>
          {currentType === "Regular" && (
            <RegularEmployees
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
              currentMonthData={currentMonthData}
              userRole={userRole}
              paydate={paydate}
              worklocationData={worklocationData}
              handleWorkLoacation={handleWorkLoacation}
            />
          )}
          {currentType === "Work-Based" && (
            <WorkBasedEmployees
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
              currentMonthData={currentMonthData}
              userRole={userRole}
              paydate={paydate}
              worklocationData={worklocationData}
              handleWorkLoacation={handleWorkLoacation}
            />
          )}
          {currentType === "Contractual" && (
           <ContractualEmployees
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
              currentMonthData={currentMonthData}
              userRole={userRole}
              paydate={paydate}
              worklocationData={worklocationData}
              handleWorkLoacation={handleWorkLoacation}
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default MonthlyManagementView;
